module.exports = __webpack_public_path__ + "static/img/5.cdf8992.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/3/eng/5.png
// module id = b9SF
// module chunks = 0